<template>
    <thead>
        <tr>
            <th>Nom - Prénom</th>
            <th>Validé</th>
            <th v-if="mode == 'admin'">Statut</th>
        </tr>
    </thead>
</template>

<script>
export default {
    props: ["mode"],
    name: 'BilletterieInscriptionThead',
};
</script>

<style scoped>
/* Your styles go here */
</style>